export const COLORS = {
	/* TRANSPARENT: 'transparent',
    WHITE: 'rgb(255,255,255)',
    BLACK: 'rgb(0,0,0)',
    RED: 'rgb(255,50,50)',
    BACKGROUND_GREY: 'rgb(248,248,248)',
    TABLE_ROW_BORDER_GREY: 'rgb(240,240,240)',
    FOOTER_GREY: 'rgb(240,240,240)',
    ICON_GREY: 'rgb(112,112,112)',
    CHECKBOX_GREY: 'rgb(90,90,90)',
    BUTTON_GREY: 'rgb(70,70,70)',
    BUTTON_GREEN: 'rgb(48,153,64)',
    INPUT_GREY: 'rgba(0, 0, 0, 0.05)',
    INPUT_GREY_HOVER: 'rgba(0, 0, 0, 0.10)',*/

	PRIMARY: 'rgb(245,129,52)',
	PRIMARY__HEX: '#F58134',
	PRIMARY2: 'rgb(183,188,193)',
	SECONDARY: 'rgb(44,76,84)',
	SECONDARY__HEX: '#2C4C54',
	SECONDARY2: 'rgb(104,130,147)',
	SECONDARY2__HEX: '#688293',
	LINK: 'rgb(0,105,147)',
	LINK__HEX: '#006993',
	BORDER: 'rgb(220,226,232)',
	BORDER_TABLE_ROW: 'rgb(230,230,230)',
	BORDER_TABLE_ROW_DARK: 'rgb(220,220,220)',
	BACKGROUND: 'rgb(255,255,255)',
	BACKGROUND_GREY_DARK: 'rgb(77,85,85)',
	BACKGROUND_GREY_LIGHT: 'rgb(240,240,240)',
	BACKGROUND_INPUT: 'rgb(243,244,245)',
	BACKGROUND_INPUT_HOVER: 'rgb(232,232,232)',
	BACKGROUND_SEARCH: 'rgba(255, 255, 255, 1)',
	TEXT_SECONDARY: 'rgba(0,0,0,.6)',
	WHITE: 'rgb(255,255,255)',
	DIGITAL_PRIMARY_SECONDARY_2: '#DCE2E8',
	BACKGROUND_BACKGROUND_CARD: '#FCFCFD',
	ICON_ORANGE: 'rgb(255, 121, 32)'
};

export const DIMENSIONS = {
	FILTERS_PANEL_WIDTH: 290,
	FILTERS_PANEL_MIN_WIDTH: 200,
	NAVBAR_HEIGHT: 64,
	NAVBAR_HEIGHT_XS: 58,
	SEARCHBAR_HEIGHT: 44,
	SELECT_MENU_ITEM_HEIGHT: 36,
	SKELETON_BUTTON_WIDTH: 130,
	SKELETON_BUTTON_HEIGHT: 44,
	SKELETON_TABLE_ROW_HEIGHT: 80,
	SKELETON_TEXT_HEIGHT: 30,
	SKELETON_TITLE_HEIGHT: 38
};

export const FONT_FAMILIES = ['Inter', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(',');
// export const FONT_FAMILIES_MONO = ["Inter", "Roboto", "Helvetica", "Arial", "sans-serif", "monospace"].join(",");

export const FONT_SIZES = {
	H1: '2.5rem', // 40px
	H2: '2.125rem', // 34px
	H3: '1.875rem', // 30px
	H4: '1.675rem', // 26px
	H5: '1.375rem', // 22px
	H6: '1.125rem', // 18px
	SUBTITLE1: '1rem', // 16px
	SUBTITLE2: '0.938rem', // 15px
	BODY1: '0.875rem', // 14px
	BODY2: '0.813rem', // 13px
	CAPTION: '0.688rem' // 11px
};

export const CN_FONT_SIZES = {
	H1: '3.075rem', // 40px
	H2: '2.613rem', // 34px
	H3: '2.306rem', // 30px
	H4: '2.060rem', // 26px
	H5: '1.691rem', // 22px
	H6: '1.383rem', // 18px
	SUBTITLE1: '1.23rem', // 16px
	SUBTITLE2: '1.153rem', // 15px
	BODY1: '1.076rem', // 14px
	BODY2: '0.999rem', // 13px
	CAPTION: '0.846rem' // 11px
};

export const SPACING = 3;

export const NUMBER_OF_SKELETON_TABLE_ROWS = 8;
export const NUMBER_OF_SKELETON_TABLE_FILTERS_ROWS = 10;
